import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import ReactQuill from 'react-quill'; 
import '../../../assets/css/quill-snow.css';

import { MSG_TERMS_FETCH_FAILED, MSG_TERMS_ACCEPTED, MSG_TERMS_ACCEPT_ERROR, MSG_TERMS_SELECT_ERROR } from '../../../configs/msgConfigs';
import * as labelConfigs from '../../../configs/labelConfigs';
import * as staticConfigs from '../../../configs/staticConfigs';
import { getStorage, setStorage, getUserGroupData } from '../../../utils/browserStorage';
import Toast from '../../commons/helpers/toast';

import { termsLoadAction, termsAcceptAction } from '../../../actions/termsActions'; 
import { clearAction } from '../../../actions/commonActions';
import { TERMS_LOAD_SUCCESS, TERMS_LOAD_ERROR, TERMS_ACCEPT_SUCCESS, TERMS_ACCEPT_ERROR } from '../../../actions'; 

import { LBL_I_ACCEPT, LBL_TERMS_AND_CONDITIONS, LBL_CLOSE, LBL_CANCEL, LBL_I_ACCEPT_TERMS } from '../../../configs/labelConfigs';

class TermsAcceptComponent extends Component {

    static propTypes = {
        location: PropTypes.object.isRequired,
    };

    constructor(props){
        super();

        this.state = { 
            userGroup:null,
            errorMessage:'',
            termsAccepted:false, 
            termsLoadActivity:'',
            termsId: 0, 
            termsText: '',
            termsUserData:{
                txtUsername: null,
                txtPassword:null,
                sel_affiliate: 0,
            },
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true, 
            returnURL: '',
            iAgreeChecked:false, 
        }
    } 

    componentDidMount() {
        document.title = labelConfigs.LBL_APP_NAME+' : Login';
        document.body.classList.add('login');
        const { location } = this.props;
        let userGroup = '';
        let pathStr = location.pathname.toLowerCase().trim(); 
        let returnURL = ''; 
        if (pathStr===staticConfigs.ROUTE_TERMS_ACCEPT || pathStr===(staticConfigs.ROUTE_TERMS_ACCEPT+'/')){
            userGroup = staticConfigs.LOGIN_SUPER_ADMIN_GROUP;
            document.body.classList.add('body-super');
            this.props.termsLoadAction({groupId:userGroup});
            returnURL = staticConfigs.LOGIN_ROUTE_SUPER_ADMIN; 
        }else if(pathStr === staticConfigs.ROUTE_AFFILIATE_TERMS_ACCEPT || pathStr===(staticConfigs.ROUTE_AFFILIATE_TERMS_ACCEPT+'/')){
            userGroup = staticConfigs.LOGIN_AFFILIATE_GROUP;
            document.body.classList.add('body-affiliate'); 
            this.props.termsLoadAction({groupId:userGroup});
            returnURL = staticConfigs.LOGIN_ROUTE_AFFILIATE; 
        }else if(pathStr === staticConfigs.ROUTE_CLIENT_TERMS_ACCEPT || pathStr===(staticConfigs.ROUTE_CLIENT_TERMS_ACCEPT+'/')){
            userGroup = staticConfigs.LOGIN_CLIENT_GROUP;
            document.body.classList.add('body-client');
            this.props.termsLoadAction({groupId:userGroup});
            returnURL = staticConfigs.LOGIN_ROUTE_CLIENT; 
        }

        let termsUserData = JSON.parse(getStorage('termsUserData')); // , JSON.stringify(this.state.userData));
        this.setState({userGroup:userGroup,termsUserData,returnURL}); 
        
    }

    componentDidUpdate(prevProps) {
        const {termsData,termsStatus,termsLoadActivity,errorData,termsAcceptData,termsAcceptStatus} = this.props;    
        if (termsLoadActivity !== prevProps.termsLoadActivity) { 
            let arrResp = [] ;
            if(termsLoadActivity) arrResp = termsLoadActivity.split('~~'); 
            let actString = arrResp[0]; 
            if(termsStatus==200 && actString===TERMS_LOAD_SUCCESS) {
                this.setState({
                    errorMessage: '',
                    termsLoadActivity: termsLoadActivity,
                    termsId: termsData[0].id, 
                    termsText: termsData[0].condition_text, 
                });
                this.hideQuillToolbar(); 
            }
            else if (termsStatus!=200 || actString===TERMS_LOAD_ERROR) {
                this.setState( {
                    errorMessage: MSG_TERMS_FETCH_FAILED,
                    termsLoadActivity: termsLoadActivity
                });
                this.setToasterState(true,MSG_TERMS_FETCH_FAILED,false,false); 
            }
            else if(termsAcceptStatus==200 && actString===TERMS_ACCEPT_SUCCESS) {
                this.setToasterState(true,MSG_TERMS_ACCEPTED,true,false); 
                this.setState({
                    errorMessage: '',
                    termsLoadActivity: termsLoadActivity
                });
                this.props.history.push(this.state.returnURL); 
            } 
            else if(termsAcceptStatus!=200 && actString===TERMS_ACCEPT_ERROR) {
                this.setState({
                    errorMessage: '',
                    termsLoadActivity: termsLoadActivity
                });
                this.setToasterState(true,MSG_TERMS_ACCEPT_ERROR,false,false);    
            }
        }
    }

    onHandleChange = (event) =>{
        if(this.state.iAgreeChecked)  this.setState({errorMessage:MSG_TERMS_SELECT_ERROR, iAgreeChecked:false});
        else this.setState({errorMessage:'', iAgreeChecked:true});
    }

    onHandleLogin = (event) => {
        event.preventDefault();
        if(this.state.iAgreeChecked) {
            this.props.termsAcceptAction({username:this.state.termsUserData.txtUsername, terms_id:this.state.termsId});
        }
        else {
            this.setState({errorMessage:MSG_TERMS_SELECT_ERROR}); 
        }
    }

    hideQuillToolbar = () => {
        var divToHide = document.getElementsByClassName("ql-toolbar"); 
        //var divToHide = document.getElementsByClassName("ql-formats"); 
        for(var i = 0; i < divToHide.length; i++) {
            divToHide[i].classList.add('zero-height'); // remove-border bottom-border-only
            divToHide[i].style.visibility="hidden"; 
            divToHide[i].style.height ="0px";
        }

        var divContainer = document.getElementsByClassName("ql-container"); 
        for(var i = 0; i < divContainer.length; i++) {
            //divContainer[i].classList.add('add-top-border');  
            divContainer[i].classList.add('remove-border');
        }  
    }

    setToasterState(isEnabled,message,isSucces,isAutoHide=true,delay=3000){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        if(isAutoHide){
            setTimeout(()=> {
                this.onCloseToast();
            }, delay);
        }    
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
    } 

    render() {
        let toolbarOptions = [];
        const { toastMessage,toastFlag,toastSuccess } = this.state 

        return (
            <React.Fragment>
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="terms-box">
                    <div> 
                        <form className="col-md-12">
                            <div className="" >
                                {/* <div className="terms-header">
                                    <label>{LBL_TERMS_AND_CONDITIONS}</label>
                                </div> */}
                                <div className="quill-content-scroll border-grey">
                                    {/* {ReactHtmlParser(this.state.termsText)} */}
                                    <ReactQuill value={this.state.termsText} 
                                        readOnly={true} modules={{ toolbar: toolbarOptions}} />
                                </div>
                                <div>&nbsp;</div>
                                <div>
                                    {/* {this.state.errorMessage.length >0 && (
                                    <div className="text-red text-12 text-right">{this.state.errorMessage}</div> )}  */}
                                    <div className="custom-checkbox"> 
                                        <input type="checkbox" name={'iAgreeChecked'} id={'iAgreeChecked'} 
                                        checked={this.state.iAgreeChecked ? true : false} 
                                        onChange={(e) => this.onHandleChange(e)}  /> <label className="checkbox" htmlFor={'iAgreeChecked'}></label><label className="labeltext" htmlFor={'iAgreeChecked'}>{LBL_I_ACCEPT_TERMS}</label> 
                                    </div>
                                        
                                    <div className="float-right">  
                                        {/* <button  type="button" className="btn btn-primary saveBtnMinWidth" onClick={this.saveFormData} >{LBL_I_ACCEPT}</button>    */}
                                        {this.state.iAgreeChecked && <button onClick={this.onHandleLogin} className="btn btn-primary saveBtnMinWidth">{LBL_I_ACCEPT}</button>}   
                                    </div>  
                                </div>
                                    
                                {/* <div className="form-group">
                                    
                                </div> */}
                                <div>&nbsp;</div>
                                <div>&nbsp;</div>
                            </div>
                        </form>
                    </div>
                </div>
            </React.Fragment>            
        )
    }
}

const mapStateToProps = (state) => {
    return {
        termsData : state.terms.termsData,
        termsStatus:state.terms.termsStatus,
        termsLoadActivity:state.terms.termsLoadActivity, 
        termsAcceptData:state.terms.termsAcceptData, 
        termsAcceptStatus:state.terms.termsAcceptStatus,                 
        errorData:state.terms.errorData,
    }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
       termsLoadAction:termsLoadAction,
       termsAcceptAction:termsAcceptAction, 
       clearAction:clearAction
  },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(TermsAcceptComponent);